"use client";

import React from "react";

interface LogoProps {
    className?: string;
    width?: number;
    height?: number;
}

export default function Logo({ className, width = 50, height = 50 }: LogoProps) {
    return (
        <div className={`relative transition-all hover:scale-[1.05] group ${className}`} style={{ width, height }}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 848 848"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="overflow-visible"
            >
                <rect width="848" height="848" fill="#191B1E" className="rounded-[80px]" rx="80" />
                <g filter="url(#filter0_ng_2002_21)">
                    <path
                        d="M424 133L459.83 325.558L611.051 201.081L514.725 371.62L710.579 373.469L527.168 442.192L676.013 569.5L491.338 504.251L523.528 697.451L424 528.76L324.472 697.451L356.662 504.251L171.987 569.5L320.832 442.192L137.421 373.469L333.275 371.62L236.949 201.081L388.17 325.558L424 133Z"
                        fill="#FEFEFE"
                        className="transition-transform  duration-700 ease-in-out group-hover:rotate-[100deg] origin-center"
                        style={{ transformOrigin: "424px 424px" }}
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_ng_2002_21"
                        x="133.821"
                        y="129.4"
                        width="580.358"
                        height="571.651"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feTurbulence
                            type="fractalNoise"
                            baseFrequency="0.55555558204650879 0.55555558204650879"
                            stitchTiles="stitch"
                            numOctaves="3"
                            result="noise"
                            seed="9383"
                        />
                        <feComponentTransfer in="noise" result="coloredNoise1">
                            <feFuncR type="linear" slope="2" intercept="-0.5" />
                            <feFuncG type="linear" slope="2" intercept="-0.5" />
                            <feFuncB type="linear" slope="2" intercept="-0.5" />
                            <feFuncA
                                type="discrete"
                                tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
                            />
                        </feComponentTransfer>
                        <feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped" />
                        <feComponentTransfer in="noise1Clipped" result="color1">
                            <feFuncA type="table" tableValues="0 0.15" />
                        </feComponentTransfer>
                        <feMerge result="effect1_noise_2002_21">
                            <feMergeNode in="shape" />
                            <feMergeNode in="color1" />
                        </feMerge>
                        <feTurbulence
                            type="fractalNoise"
                            baseFrequency="1.1111111640930176 1.1111111640930176"
                            numOctaves="3"
                            seed="1955"
                        />
                        <feDisplacementMap
                            in="effect1_noise_2002_21"
                            scale="7.1999998092651367"
                            xChannelSelector="R"
                            yChannelSelector="G"
                            result="displacedImage"
                            width="100%"
                            height="100%"
                        />
                        <feMerge result="effect2_texture_2002_21">
                            <feMergeNode in="displacedImage" />
                        </feMerge>
                    </filter>
                </defs>
            </svg>
        </div>
    );
}
